import { useMutation } from '@tanstack/react-query';

import { postHangfireDashboardSession } from '../endpoints/hangfireDashboard';

export const useCreateHangfireDashboardSessionMutation = () =>
    useMutation({
        mutationFn: async () => {
            return await postHangfireDashboardSession();
        },
    });
